import { alpha, useColorScheme } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

export default function PlatformDesc() {
  const { mode } = useColorScheme();
  return (
    <Box
      id="hero"
      sx={(theme) => ({
        width: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundImage: `radial-gradient(ellipse 80% 50% at 50% -20%, ${alpha(theme.palette.primary.light, 0.35)}, transparent)`,
        ...theme.applyStyles('dark', {
          backgroundImage: `radial-gradient(ellipse 80% 50% at 50% -20%, ${alpha(theme.palette.primary.dark, 0.25)}, transparent)`,
        }),
      })}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: '14rem', sm: '18rem' },
          pb: { xs: '1rem', sm: '2rem' },
        }}
      >
        <Box textAlign="center">
          <img
            src={mode === "dark"
              ? "/ProcurementLogo-dark.png"
              : "/ProcurementLogo-light.png"}
            alt="Logo"
            style={{ height: '180px' }}
          />
        </Box>
      </Container>
    </Box>
  );
}
